import React from 'react';
import SupplierMetersIndexPage from '../supplier_meters_index_page/SupplierMetersIndexPage';

export default function SupplierMetersAllIndexPage() {
	return <SupplierMetersIndexPage preAppliedFilters={{}} targetCollectionName="allMetersIndex" />;
}
